import i from "../assets/abi/polygon-adeptus.json.js";
import n from "../assets/abi/polygon-anima.json.js";
import O from "../assets/abi/polygon-apostle.json.js";
import N from "../assets/abi/polygon-apostle-season-mint-caller.json.js";
import p from "../assets/abi/polygon-apostle-ticket-mint.json.js";
import t from "../assets/abi/polygon-apostle-ticket-origin.json.js";
import I from "../assets/abi/polygon-apostle-ticket-s2.json.js";
import m from "../assets/abi/polygon-aprs.json.js";
import e from "../assets/abi/polygon-born.json.js";
import A from "../assets/abi/polygon-breed.json.js";
import P from "../assets/abi/polygon-bridge-burner.json.js";
import B from "../assets/abi/polygon-burn-time.json.js";
import R from "../assets/abi/polygon-daily-check-in.json.js";
import E from "../assets/abi/polygon-expedition-type1.json.js";
import f from "../assets/abi/polygon-expedition-type1-key.json.js";
import o from "../assets/abi/polygon-expedition-type1-prize.json.js";
import T from "../assets/abi/polygon-expedition-type2.json.js";
import y from "../assets/abi/polygon-expedition-type2-key.json.js";
import Y from "../assets/abi/polygon-expedition-type3.json.js";
import G from "../assets/abi/polygon-expedition-type3-key.json.js";
import L from "../assets/abi/polygon-expedition-type3-prize.json.js";
import l from "../assets/abi/polygon-expedition-type4.json.js";
import a from "../assets/abi/polygon-expedition-type4-key.json.js";
import d from "../assets/abi/polygon-expedition-type4-prize.json.js";
import g from "../assets/abi/polygon-expedition-type5.json.js";
import s from "../assets/abi/polygon-expedition-type5-key.json.js";
import S from "../assets/abi/polygon-expedition-type5-prize.json.js";
import x from "../assets/abi/polygon-fragment.json.js";
import k from "../assets/abi/polygon-godiverse.json.js";
import K from "../assets/abi/polygon-marketplace-721.json.js";
import M from "../assets/abi/polygon-marketplace-1155.json.js";
import C from "../assets/abi/polygon-orbital-track.json.js";
import D from "../assets/abi/polygon-orbital-track-caller.json.js";
import c from "../assets/abi/polygon-planet.json.js";
import _ from "../assets/abi/polygon-star.json.js";
import F from "../assets/abi/polygon-star-attach-godiverse.json.js";
import U from "../assets/abi/polygon-usdc.json.js";
import u from "../assets/abi/polygon-vesting.json.js";
import z from "../assets/abi/polygon-weth.json.js";
import W from "../assets/abi/ronin-adeptus.json.js";
import V from "../assets/abi/ronin-anima.json.js";
import h from "../assets/abi/ronin-anima-wron.json.js";
import Z from "../assets/abi/ronin-apeiron-marketplace-gateway-proxy.json.js";
import H from "../assets/abi/ronin-apeiron-token-converter.json.js";
import b from "../assets/abi/ronin-apostle.json.js";
import X from "../assets/abi/ronin-apostle-bounty.json.js";
import v from "../assets/abi/ronin-apostle-extension-proxy.json.js";
import w from "../assets/abi/ronin-apostle-season-mint-caller.json.js";
import q from "../assets/abi/ronin-apostle-spiritual-merge-proxy.json.js";
import Q from "../assets/abi/ronin-apostle-ticket-mint.json.js";
import j from "../assets/abi/ronin-apostle-ticket-origin.json.js";
import J from "../assets/abi/ronin-apostle-ticket-s2.json.js";
import $ from "../assets/abi/ronin-aprs.json.js";
import oo from "../assets/abi/ronin-aprs-wron.json.js";
import ro from "../assets/abi/ronin-born.json.js";
import io from "../assets/abi/ronin-breed.json.js";
import no from "../assets/abi/ronin-bridge-minter.json.js";
import Oo from "../assets/abi/ronin-burn-time.json.js";
import No from "../assets/abi/ronin-daily-check-in.json.js";
import po from "../assets/abi/ronin-doodipals-doodinomics.json.js";
import to from "../assets/abi/ronin-expedition-type1.json.js";
import Io from "../assets/abi/ronin-expedition-type1-key.json.js";
import r from "../assets/abi/ronin-expedition-type1-prize.json.js";
import mo from "../assets/abi/ronin-expedition-type2.json.js";
import eo from "../assets/abi/ronin-expedition-type2-key.json.js";
import Ao from "../assets/abi/ronin-expedition-type3.json.js";
import Po from "../assets/abi/ronin-expedition-type3-key.json.js";
import Bo from "../assets/abi/ronin-expedition-type3-prize.json.js";
import Ro from "../assets/abi/ronin-expedition-type4.json.js";
import Eo from "../assets/abi/ronin-expedition-type4-key.json.js";
import fo from "../assets/abi/ronin-expedition-type4-prize.json.js";
import To from "../assets/abi/ronin-expedition-type5.json.js";
import yo from "../assets/abi/ronin-expedition-type5-key.json.js";
import Yo from "../assets/abi/ronin-expedition-type5-prize.json.js";
import Go from "../assets/abi/ronin-expedition-type6.json.js";
import Lo from "../assets/abi/ronin-expedition-type6-key.json.js";
import lo from "../assets/abi/ronin-expedition-type6-prize.json.js";
import ao from "../assets/abi/ronin-expedition-type7.json.js";
import go from "../assets/abi/ronin-expedition-type7-key.json.js";
import so from "../assets/abi/ronin-expedition-type7-prize.json.js";
import So from "../assets/abi/ronin-expedition-type8.json.js";
import xo from "../assets/abi/ronin-expedition-type8-key.json.js";
import ko from "../assets/abi/ronin-expedition-type8-prize.json.js";
import Ko from "../assets/abi/ronin-fragment.json.js";
import Mo from "../assets/abi/ronin-godiverse.json.js";
import Co from "../assets/abi/ronin-liquidity-permissioned-router.json.js";
import Do from "../assets/abi/ronin-market-gateway-proxy.json.js";
import co from "../assets/abi/ronin-nft.json.js";
import _o from "../assets/abi/ronin-orbital-track.json.js";
import Fo from "../assets/abi/ronin-orbital-track-caller.json.js";
import Uo from "../assets/abi/ronin-planet.json.js";
import uo from "../assets/abi/ronin-planet-apostle-forge.json.js";
import zo from "../assets/abi/ronin-planet-apostle-manage.json.js";
import Wo from "../assets/abi/ronin-planet-chronomerging-proxy.json.js";
import Vo from "../assets/abi/ronin-star.json.js";
import ho from "../assets/abi/ronin-star-attach-godiverse.json.js";
import Zo from "../assets/abi/ronin-usdc.json.js";
import Ho from "../assets/abi/ronin-vesting.json.js";
import bo from "../assets/abi/ronin-vip-shop-token-purchase.json.js";
import Xo from "../assets/abi/ronin-vip-token-staking.json.js";
import vo from "../assets/abi/ronin-weth.json.js";
import wo from "../assets/abi/ronin-wron.json.js";
const Zi = {
  ADEPTUS: {
    POLYGON: i,
    RONIN: W
  },
  APOSTLE: {
    INFO: {
      POLYGON: O,
      RONIN: b
    },
    MINT: {
      POLYGON: N,
      RONIN: w
    },
    MANAGE: {
      POLYGON: [],
      RONIN: zo
    },
    FORGE: {
      POLYGON: [],
      RONIN: uo
    },
    EXTENSION: {
      POLYGON: [],
      RONIN: v
    },
    SPIRITUAL_MERGE: {
      POLYGON: [],
      RONIN: q
    }
  },
  APOSTLE_TICKET: {
    ORIGIN: {
      POLYGON: t,
      RONIN: j
    },
    S2: {
      POLYGON: I,
      RONIN: J
    },
    MINT: {
      POLYGON: p,
      RONIN: Q
    }
  },
  BATTLE_DEMO: {
    BURN_TIME: {
      POLYGON: B,
      RONIN: Oo
    },
    FRAGMENT: {
      POLYGON: x,
      RONIN: Ko
    }
  },
  BRIDGE: {
    BURN: {
      POLYGON: P,
      RONIN: []
      // roninBridgeBurnerABI
    },
    MINT: {
      POLYGON: [],
      // polygonBridgeMinterABI
      RONIN: no
    }
  },
  BOUNTY: {
    APOSTLE: {
      POLYGON: [],
      RONIN: X
    }
  },
  CURRENCY: {
    ANIMA: {
      POLYGON: n,
      RONIN: V
    },
    APRS: {
      POLYGON: m,
      RONIN: $
    },
    USDC: {
      POLYGON: U,
      RONIN: Zo
    },
    WETH: {
      POLYGON: z,
      RONIN: vo
    },
    WRON: {
      POLYGON: [],
      // polygonWronABI,
      RONIN: wo
    },
    APRS_WRON: {
      POLYGON: [],
      // polygonAprsWronABI,
      RONIN: oo
    },
    ANIMA_WRON: {
      POLYGON: [],
      // polygonAnimaWronABI,
      RONIN: h
    }
  },
  TOKEN_CONVERTER: {
    POLYGON: [],
    RONIN: H
  },
  DAILY_CHECK_IN: {
    POLYGON: R,
    RONIN: No
  },
  DOODIPALS: {
    DOODINOMICS: {
      POLYGON: [],
      RONIN: po
    }
  },
  EXPEDITION: {
    TYPE1: {
      PRIZE: {
        POLYGON: o,
        RONIN: r
      },
      KEY: {
        POLYGON: f,
        RONIN: Io
      },
      INFO: {
        POLYGON: E,
        RONIN: to
      }
    },
    TYPE2: {
      PRIZE: {
        POLYGON: o,
        RONIN: r
      },
      KEY: {
        POLYGON: y,
        RONIN: eo
      },
      INFO: {
        POLYGON: T,
        RONIN: mo
      }
    },
    TYPE3: {
      PRIZE: {
        POLYGON: L,
        RONIN: Bo
      },
      KEY: {
        POLYGON: G,
        RONIN: Po
      },
      INFO: {
        POLYGON: Y,
        RONIN: Ao
      }
    },
    TYPE4: {
      PRIZE: {
        POLYGON: d,
        RONIN: fo
      },
      KEY: {
        POLYGON: a,
        RONIN: Eo
      },
      INFO: {
        POLYGON: l,
        RONIN: Ro
      }
    },
    TYPE5: {
      PRIZE: {
        POLYGON: S,
        RONIN: Yo
      },
      KEY: {
        POLYGON: s,
        RONIN: yo
      },
      INFO: {
        POLYGON: g,
        RONIN: To
      }
    },
    TYPE6: {
      PRIZE: {
        POLYGON: [],
        // polygonExpeditionPrizesType6ABI,
        RONIN: lo
      },
      KEY: {
        POLYGON: [],
        // polygonExpeditionStakingAndKeysType6ABI,
        RONIN: Lo
      },
      INFO: {
        POLYGON: [],
        // polygonExpeditionType6ABI,
        RONIN: Go
      }
    },
    TYPE7: {
      PRIZE: {
        POLYGON: [],
        // polygonExpeditionPrizesType7ABI,
        RONIN: so
      },
      KEY: {
        POLYGON: [],
        // polygonExpeditionStakingAndKeysType7ABI,
        RONIN: go
      },
      INFO: {
        POLYGON: [],
        // polygonExpeditionType7ABI,
        RONIN: ao
      }
    },
    TYPE8: {
      PRIZE: {
        POLYGON: [],
        // polygonExpeditionPrizesType8ABI,
        RONIN: ko
      },
      KEY: {
        POLYGON: [],
        // polygonExpeditionStakingAndKeysType8ABI,
        RONIN: xo
      },
      INFO: {
        POLYGON: [],
        // polygonExpeditionType8ABI,
        RONIN: So
      }
    }
  },
  GODIVERSE: {
    POLYGON: k,
    RONIN: Mo
  },
  LIQUIDITY: {
    PERMISSIONED_ROUTER: {
      POLYGON: [],
      RONIN: Co
    }
  },
  MARKETPLACE: {
    MKTP721: {
      POLYGON: K,
      RONIN: []
      // roninMarketplace721ABI
    },
    MKTP1155: {
      POLYGON: M,
      RONIN: []
      // roninMarketplace1155ABI
    },
    APEIRON_MARKETPLACE_GATEWAY_PROXY: {
      POLYGON: [],
      RONIN: Z
    },
    MARKET_GATEWAY_PROXY: {
      POLYGON: [],
      RONIN: Do
    }
  },
  PLANET: {
    BORN: {
      POLYGON: e,
      RONIN: ro
    },
    BREED: {
      POLYGON: A,
      RONIN: io
    },
    INFO: {
      POLYGON: c,
      RONIN: Uo
    },
    CHRONOMERGE: {
      POLYGON: [],
      RONIN: Wo
    }
  },
  STAR: {
    ATTACH_GODIVERSE: {
      POLYGON: F,
      RONIN: ho
    },
    INFO: {
      POLYGON: _,
      RONIN: Vo
    }
  },
  THIRD_PARTY_NFT: {
    INFO: {
      POLYGON: [],
      RONIN: co
    }
  },
  ORBITAL_TRACK: {
    CALLER: {
      POLYGON: D,
      RONIN: Fo
    },
    INFO: {
      POLYGON: C,
      RONIN: _o
    }
  },
  REWARD: {
    VESTING: {
      POLYGON: u,
      RONIN: Ho
    }
  },
  VIP: {
    TOKEN_STAKING: {
      POLYGON: [],
      RONIN: Xo
    },
    VIP_SHOP: {
      PURCHASE: {
        POLYGON: [],
        RONIN: bo
      }
    }
  }
};
export {
  Zi as default
};
//# sourceMappingURL=abi.js.map
